/**
 * The identity fields every user shape carries. Structural rather than tied to
 * `User` or `UserDetail`, so the same helper serves both, plus the token claims.
 */
type NamedUser = {
  given_name?: string
  family_name?: string
}

/**
 * A user's display name, built from the name parts the API returns.
 *
 * Both parts are optional on every user shape, so missing ones are dropped
 * rather than rendered as "undefined" or left as a stray separator. Returns an
 * empty string when neither is set; callers decide what to show instead.
 */
export const fullName = (user: NamedUser | undefined): string =>
  [user?.given_name, user?.family_name].filter((part) => !!part).join(' ')
